import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface ThreeDViewState {
  activeModel: string | null
}

const initialState: ThreeDViewState = {
  activeModel: null,
}

const threeDViewSlice = createSlice({
  name: 'threeDView',
  initialState,
  reducers: {
    setThreeDView(state, action: PayloadAction<ThreeDViewState>) {
      return {
        ...state,
        ...action.payload,
      }
    },
    resetThreeDView(state) {
      return {
        ...state,
        activeModel: null,
      }
    },
  },
})

export const { setThreeDView, resetThreeDView } = threeDViewSlice.actions

export default threeDViewSlice.reducer
